import React from 'react'

export type IOptionOperationTimesProps = {
    range: number[]
    excludedHour?: { started: number; duration: number }
}

export const OptionOperationTimes: React.FC<IOptionOperationTimesProps> = ({
    range,
    excludedHour,
}) => {
    return (
        <>
            {range.reduce((acc, val, idx) => {
                const nextVal = range[idx + 1]

                if (nextVal) {
                    if (excludedHour) {
                        const startAt = excludedHour.started
                        const endAt = excludedHour.started + excludedHour.duration
                        if (startAt >= val && endAt <= nextVal) return acc
                    }
                    const value = `${val.toLocaleString('th', {
                        minimumFractionDigits: 2,
                    })} - ${nextVal.toLocaleString('th', { minimumFractionDigits: 2 })}`
                    acc.push(
                        <option key={`${val}-${nextVal}`} value={value}>
                            {value}
                        </option>
                    )
                }
                return acc
            }, [] as JSX.Element[])}
        </>
    )
}
